import React from "react";
import { message } from "antd";
import "../style.less";

import { Parse } from "parse";
import Dropzone from "react-dropzone";

import styled from 'styled-components'

const Dropzonestyled = styled(Dropzone) `
width			: 200px;
height		: 200px;
border		: dashed 1px;
`

function beforeUpload(file) {
	const isJPG = file.type === "image/jpeg";
	const isPNG = file.type === "image/png";

	if (!isJPG && !isPNG) {
		message.error("Formats acceptés : JPG ou PNG");
	}
	const isLt2M = file.size / 1024 / 1024 < 2;
	if (!isLt2M) {
		message.error("Votre image doit faire moins de 2Mo");
	}
	return (isJPG || isPNG) && isLt2M;
}

class UploadAvatar extends React.Component {
	constructor(props) {
    super(props)

    this.state = { preview: null }
  }

	componentDidMount() {
		var ctx = this;
		var user = Parse.User.current();
		//if user already has an avatar, it is loaded in the preview and the info is dispatched to the parent component
		// so that the form value for picture is not undefined
		if ("avatar" in user.attributes && user.attributes.avatar !== undefined) {
			ctx.setState({ preview: user.attributes.avatar._url });
			this.props.onChange(user.attributes.avatar);
		}
	}

	//  TODO: Consider setting the 'accept' flag in Dropzone, rather than performing manual file validation
	//  TODO: Replace calls to console.log(...) with a proper logging library
	onDrop(acceptedFiles, rejectedFiles) {

		// Verify that empty array ws not provided
		if (acceptedFiles.length === 0) {
			return;
		}
		// Verify that only one file was provided
		if (acceptedFiles.length < 1) {
			message.error("Veuillez importer seulement une photo");
			return;
		}



		// Run manual file validation
		let file = acceptedFiles[0];
		if (!beforeUpload(file)) {
			return;
		}
		// Strip special characters from file name, and create parse file
		var name = file.name.replace(/[^a-zA-Z0-9.]/g, "");
		var parseFile = new Parse.File(name, file);
		this.setState({ preview: parseFile._source.file.preview });
		// Save Parse file to server, and notify parent Component
		// TODO: Can this be implemented using await ?
		//  this.props.onUpload(parseFile);
		parseFile
			.save()
			.then(
				file => this.props.onChange(file),

			);

	}

//a mettre après le "choisis une photo" :
// {preview && <img src={ preview } alt="preview" />}
	render() {
		const { preview } = this.state
		return (
			<Dropzonestyled onDrop={files => this.onDrop(files)}>
				<div style={{width: '100%', height: '100%', fontSize: '12px'}}>
					 {preview && <img src={ preview } style={{width: '100%', height: '100%'}} alt="preview" />}
				</div>
			</Dropzonestyled>
		);
	}
}

export default UploadAvatar;
